import React, { Component, Fragment } from "react";

import { getCategories } from "../../services/api";
import { constructError } from "../../services/errors.js";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const seasons = [
  { key: "ALL", value: "Toutes" },
  { key: "SUMMER", value: "Été" },
  { key: "WINTER", value: "Hiver" }
];

const types = [
  { key: "ski", value: "Ski" },
  { key: "snow", value: "Snow" },
  { key: "other", value: "Autre" }
];

export default class ProductInfo extends Component {
  state = {};
  async componentDidMount() {
    const categories = await getCategories(this.props.merchantCode);
    this.setState({
      categories
    });
  }

  changeInfo = (name, inJson, type) => e => {
    this.props.changeInfo(name, inJson, e.target.value, type);
  };

  checkboxChange = (name, inJson) => e => {
    this.props.changeInfo(name, inJson, e.target.checked);
  };

  render() {
    const { categories } = this.state;
    const { product, errors, merchantKind } = this.props;
    const valueErrors = errors && errors.value;
    return (
      <Grid container spacing={16}>
        <Grid item xs={12} sm={4}>
          <FormControl
            margin="normal"
            fullWidth
            error={valueErrors && valueErrors["technicalLabel"] !== undefined}
          >
            <InputLabel htmlFor="technicalLabel">Libellé technique</InputLabel>
            <Input
              id="technicalLabel"
              value={product.value.technicalLabel}
              onChange={this.changeInfo("technicalLabel", true)}
            />
            <FormHelperText>
              {valueErrors && constructError(valueErrors["technicalLabel"])}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl
            fullWidth
            margin="normal"
            error={errors && errors["productCategoryId"] !== undefined}
          >
            <InputLabel htmlFor="category">Catégorie</InputLabel>
            <Select
              value={product.productCategoryId}
              onChange={this.changeInfo("productCategoryId")}
              inputProps={{ id: "category" }}
            >
              {categories !== undefined &&
                categories.map(category => (
                  <MenuItem value={category.id} key={category.id}>
                    {category.value.technicalLabel}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText>
              {errors && constructError(errors["productCategoryId"])}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl
            fullWidth
            margin="normal"
            error={valueErrors && valueErrors["season"] !== undefined}
          >
            <InputLabel htmlFor="category">Saison</InputLabel>
            <Select
              value={product.value.season}
              onChange={this.changeInfo("season", true)}
              inputProps={{ id: "category" }}
            >
              {seasons.map(season => (
                <MenuItem value={season.key} key={season.key}>
                  {season.value}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {valueErrors && constructError(valueErrors["season"])}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={product.displayed}
                onChange={this.checkboxChange("displayed", false)}
                value="displayed"
                color="secondary"
              />
            }
            label="Visible dans le catalogue"
          />
        </Grid>
        {merchantKind === "STAND" ? (
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={product.value.quantity || false}
                  onChange={this.checkboxChange("quantity", true)}
                  value="displayed"
                  color="secondary"
                />
              }
              label="Possibilité de commander plusieurs unités"
            />
          </Grid>
        ) : null}
        {product.displayed && (
          <Fragment>
            <Grid item xs={12} sm={4}>
              <FormControl
                margin="normal"
                fullWidth
                error={valueErrors && valueErrors["minAge"] !== undefined}
              >
                <InputLabel htmlFor="minAge">Age minimum (année)</InputLabel>
                <Input
                  id="minAge"
                  value={product.value.minAge}
                  onChange={this.changeInfo("minAge", true, "number")}
                  inputProps={{ type: "number" }}
                />
                <FormHelperText>
                  {valueErrors && constructError(valueErrors["minAge"])}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                margin="normal"
                fullWidth
                error={valueErrors && valueErrors["maxAge"] !== undefined}
              >
                <InputLabel htmlFor="technicalLabel">
                  Age maximum (année)
                </InputLabel>
                <Input
                  id="maxAge"
                  value={product.value.maxAge}
                  onChange={this.changeInfo("maxAge", true, "number")}
                  inputProps={{ type: "number" }}
                />
                <FormHelperText>
                  {valueErrors && constructError(valueErrors["maxAge"])}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                fullWidth
                margin="normal"
                error={valueErrors && valueErrors["type"] !== undefined}
              >
                <InputLabel htmlFor="type">Type</InputLabel>
                <Select
                  value={product.value.type}
                  onChange={this.changeInfo("type", true)}
                  inputProps={{ id: "type" }}
                >
                  {types.map(type => (
                    <MenuItem value={type.key} key={type.key}>
                      {type.value}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {valueErrors && constructError(valueErrors["season"])}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Fragment>
        )}
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/products/ProductInfo.js